import { useAuthStore } from "../store/authStore";
import { Permission, DEFAULT_ROLE_PERMISSIONS } from "../types/roles";

export const usePermissions = () => {
  const { user } = useAuthStore();

  const hasPermission = (permission: Permission): boolean => {
    if (!user) return false;

    // This is temporal while we define user role while signing up
    const role = user.role ?? "group_admin";

    return DEFAULT_ROLE_PERMISSIONS[role].includes(permission);
  };

  const hasAnyPermission = (permissions: Permission[]): boolean => {
    return permissions.some(hasPermission);
  };

  const hasAllPermissions = (permissions: Permission[]): boolean => {
    return permissions.every(hasPermission);
  };

  return {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
  };
};
